import React, { Component } from "react";
import GoogleMapReact from "google-map-react";
import ReactDOM from "react-dom/client";
import SingleMarker from "../lib/map/singlemarker.jsx";
import Loader from "../lib/map/loader.jsx";

const initial_zoom = 16;
const max_zoom = 19;
const min_zoom = 14;
const $wrapper = $("body #wrp").length > 0 ? $("#wrp") : $("body");

class MapEdit extends Component {
  constructor(props) {
    super(props);
    // this.map = null;
    this.mapRef = React.createRef(); // Create a ref for the map

    this.citySearchTimeout = null;
    this.quarterSearchTimeout = null;
    this.keyupTimeout = null;
    this.initMap = this.initMap.bind(this);
    this.onMarkerInteraction = this.onMarkerInteraction.bind(this);
    this.onMarkerRelease = this.onMarkerRelease.bind(this);
    this.state = {
      markers: false,
      zoom: initial_zoom,
      packageName: this.props.packageName,
      packageValue: global.Translator.trans(
        "packages.value." + (packageName.value || "PLATINUM"),
        {},
        "js"
      ),
      customLat: parseFloat(this.props.lat),
      customLng: parseFloat(this.props.lng),
      center: {
        lat: parseFloat(this.props.lat),
        lng: parseFloat(this.props.lng),
      },
    };
  }

  onMarkerInteraction(childKey, childProps, mouse) {
    this.setState({
      customLat: mouse.lat,
      customLng: mouse.lng,
    });

    if (!$("body").hasClass("checkout")) {
      const mapContainer = document.querySelector("#editMap > div");
      mapContainer.style.transition = "height 0.5s";
      mapContainer.style.height = "500px";
    }
  }

  onMarkerRelease() {
    if (!$("body").hasClass("checkout")) {
      const mapContainer = document.querySelector("#editMap > div");
      mapContainer.style.height = "250px";
    }
    this.setState({
      center: { lat: this.state.customLat, lng: this.state.customLng },
    });

    $(".edit-latitude").val(this.state.customLat);
    $(".edit-longitude").val(this.state.customLng);
  }

  initMap(map, googlemaps, timeout) {
    var self = this;
    self.map = map;
    var geocoder = new googlemaps.Geocoder();
    var $autocompleteResults = $(".autocomplete-wrap .results");
    var loadTimeout = timeout || 4000;
    $(".geocoder").on("keyup", function (e) {
      if ($autocompleteResults.find(".loader").length == 0) {
        $autocompleteResults.html(
          "<li class='tc'>" +
            '<svg class="icon loader" width="16" height="16"><use href="#loader"></use></svg>' +
            "</li>"
        );
      }

      self.prepareGeocoder(geocoder, $autocompleteResults);
    });

    if (this.state.center.lat && this.state.center.lng) {
      self.setState({
        customLat: this.state.center.lat,
        customLng: this.state.center.lng,
        center: { lat: this.state.center.lat, lng: this.state.center.lng },
        zoom: initial_zoom,
        markers: true,
      });
      self.defineFormattedAddress();
    } else {
      self.prepareGeocoder(geocoder, $autocompleteResults);
    }
  }

  prepareGeocoder(geocoder, $autocompleteResults) {
    var self = this;
    var doGeocode = true;
    let address = "";
    $(".geocoder:visible").each(function (index, item) {
      let $item = $(item);
      let value = $item.val() !== null ? $item.val().trim() : "";
      if (
        $("#rental_formatted_location").length == 0 &&
        $item.attr("id") == "rental_city" &&
        value == ""
      ) {
        doGeocode = false;
        $autocompleteResults.find("li").off("click").remove();
      } else {
        if (
          $("#rental_formatted_location").length &&
          $("#rental_formatted_location").is(":visible") &&
          $("#rental_formatted_location").val().length
        ) {
          address = $("#rental_formatted_location").val();
          return;
        } else {
          address = address + " " + value;
        }
      }
    });
    if (doGeocode && address.trim() != "") {
      self.geocodeAddress(address.trim(), geocoder, $autocompleteResults);
    }
  }
  defineFormattedAddress() {
    if (
      $("#rental_formatted_location").length &&
      $("#rental_formatted_location").val() == "" &&
      $(".geocoder[data-type=city]").val() != null
    ) {
      let formatted_address =
        $(".geocoder[data-type=street]").val() +
        " " +
        $(".geocoder[data-type=street_no]").val() +
        ", " +
        $(".geocoder[data-type=zipcode]").val() +
        " " +
        $(".geocoder[data-type=city]").val();
      $("#rental_formatted_location").val(formatted_address);
    }
  }
  geocodeAddress(address, geocoder, $autocompleteResults) {
    var self = this;
    clearTimeout(this.keyupTimeout);
    this.keyupTimeout = setTimeout(function () {
      geocoder.geocode({ address: address }, function (results, status) {
        $autocompleteResults.find("li").off("click").remove();
        if (status === "OK") {
          $.each(results, function (index, item) {
            var itemJson = encodeURIComponent(JSON.stringify(item));
            $autocompleteResults.append(
              "<li class='address-link' data-result=" +
                itemJson +
                ">" +
                '<svg class="icon circle_check" width="12" height="12"><use href="#circle_check"></use></svg>&nbsp;' +
                item.formatted_address +
                "</li>"
            );
            if (index == 0) {
              if ($("body").hasClass("checkout")) {
                //self.autocompleteAddress(JSON.parse(decodeURIComponent(itemJson)), false)
              } else if (!self.elementInViewport($autocompleteResults[0])) {
                $("html, body").animate(
                  {
                    scrollTop:
                      $(".geocoder[data-type=street]").offset().top - 70,
                  },
                  "slow"
                );
              }
              // dont use item directly, it will cause encoding issues
              self.updateState(JSON.parse(decodeURIComponent(itemJson)));
            }
          });
          $autocompleteResults
            .find("li.address-link")
            .one("click", function (e) {
              var geocodeItem = JSON.parse(
                decodeURIComponent($(this).attr("data-result"))
              );
              self.autocompleteAddress(geocodeItem, true);
              clearTimeout(self.keyupTimeout);
              if (
                $(this).parents(".autocomplete-wrap.formatted-address")
                  .length &&
                document.querySelector("#address-edit a.toggler") !== null
              ) {
                document.querySelector("#address-edit a.toggler").click();
              }
              $autocompleteResults.find("li").off("click").remove();
              self.updateState(geocodeItem);
              e.stopPropagation();
            });
        } else {
          self.reset();
          console.log(
            "Geocode was not successful for the following reason: " + status
          );
        }
      });
    }, 1000);
  }

  reset() {
    this.setState({
      customLat: parseFloat(this.props.lat),
      customLng: parseFloat(this.props.lng),
      center: {
        lat: parseFloat(this.props.lat),
        lng: parseFloat(this.props.lng),
      },
      markers: false,
      zoom: min_zoom,
    });
    this.map.setCenter(this.state.center);
  }

  elementInViewport(el) {
    var top = el.offsetTop || 0;
    var left = el.offsetLeft || 0;
    var width = el.offsetWidth || 0;
    var height = el.offsetHeight || 0;

    while (el.offsetParent) {
      el = el.offsetParent;
      top += el.offsetTop || 0;
      left += el.offsetLeft || 0;
    }

    return (
      top >= window.scrollY &&
      left >= window.scrollX &&
      top + height <= window.scrollY + window.innerHeight &&
      left + width <= window.scrollX + window.innerWidth
    );
  }
  updateState(geocodeItem) {
    var self = this;
    const lat = parseFloat(geocodeItem.geometry.location.lat);
    const lng = parseFloat(geocodeItem.geometry.location.lng);
    self.setState({
      customLat: lat,
      customLng: lng,
      center: { lat: lat, lng: lng },
      zoom: initial_zoom,
      markers: true,
    });

    $(".edit-latitude").val(lat);
    $(".edit-longitude").val(lng);

    self.setCityId();

    $.each(geocodeItem["address_components"], function (index, $item) {
    if ($item["types"].includes("sublocality")) {
      let $input = $(".js-quarter .name");
      $input
        .text($item["long_name"].replace('Bezirk ',''))
        .append(
          '<svg class="icon close ms-1" width="10" height="10"><use href="#close"></use></svg>'
        );
      self.setQuarter($item["short_name"].replace('Bezirk ',''));
    }});
    self.map.setCenter(self.state.center);
  }
  autocompleteAddress(geocodeItem, force) {
    var self = this;

    if (
      ($("#rental_formatted_location").length &&
        !$("#rental_formatted_location").is(":visible")) ||
      force
    ) {
      $("#rental_formatted_location").val(geocodeItem["formatted_address"]);
    }

    $.each(geocodeItem["address_components"], function (index, $item) {
      var $type = $item["types"][0];
      let prevValue = "";
      let field = "";
      let $input = "";
      if ($item["types"].includes("sublocality")) {
        $input = $(".js-quarter .name");
        $input
          .text($item["long_name"].replace('Bezirk ',''))
          .append(
            '<svg class="icon close ms-1" width="10" height="10"><use href="#close"></use></svg>'
          );
        self.setQuarter($item["short_name"].replace('Bezirk ',''));
      }
      switch ($type) {
        case "route":
          field = "street";
          $input = $(".geocoder[data-type=street]");
          prevValue = $input.val();
          $input
            .val($item["long_name"])
            .next("label")
            .addClass("mdc-floating-label--float-above");
          break;

        case "street_number":
          field = "street_no";
          $input = $(".geocoder[data-type=street_no]");
          prevValue = $input.val();
          $input
            .val($item["long_name"])
            .next("label")
            .addClass("mdc-floating-label--float-above");
          break;

        case "locality":
          field = "city";
          $input = $(".geocoder[data-type=city]");
          prevValue = $input.val();
          $input
            .val($item["long_name"])
            .next("label")
            .addClass("mdc-floating-label--float-above");
          break;

        case "postal_code":
          field = "zipcode";
          $input = $(".geocoder[data-type=zipcode]");
          prevValue = $input.val();
          let $zipcodeName = $item["long_name"];
          if ($zipcodeName.length < 4 && $input.val().length >= 4) {
            $zipcodeName = $input.val();
          }
          $input
            .val($zipcodeName)
            .next("label")
            .addClass("mdc-floating-label--float-above");
          break;

        case "country":
          let $countrySelect = $(".geocoder[data-type=country]");
          $countrySelect
            .val($item["short_name"])
            .next("label")
            .addClass("mdc-floating-label--float-above");
          $countrySelect
            .find("option[value=" + $item["short_name"] + "]")
            .attr("selected", "selected");
          $countrySelect.trigger("change");

          let event = new Event("change", {
            country: $item["short_name"],
            bubbles: true,
          });
          /* hackstart */
          event.simulated = true;
          let tracker = $countrySelect[0]._valueTracker;
          if (tracker) {
            tracker.setValue($item["short_name"]);
          }
          /* hackend */
          $countrySelect[0].dispatchEvent(event);
          break;
      }
      if (field != "" && $input != "") {
        let event = new Event("input", { bubbles: true });
        /* hackstart */
        event.simulated = true;
        let tracker = $input[0]._valueTracker;
        if (tracker) {
          tracker.setValue(prevValue);
        }
        /* hackend */
        $input[0].dispatchEvent(event);
      }
    });
    self.updateState(geocodeItem);
  }

  setCityId() {
    if ($("#rental_registration_number").length || $(".edit-city-id").length) {
      var cityName = $(".geocoder[data-type=city]").val();
      var country_code = $(".geocoder[data-type=country]").val();
      if (cityName !== "") {
        clearTimeout(this.citySearchTimeout);
        this.citySearchTimeout = setTimeout(function () {
          let jsonUrl =
            base_url +
            "/admin/autocomplete?q=" +
            cityName +
            "&t=city&lat=" +
            $(".edit-latitude").val() +
            "&lng=" +
            $(".edit-longitude").val();
            if(country_code) {
              jsonUrl += "&country_code=" + country_code;
            }
          window
            .fetch(jsonUrl)
            .then((res) => res.json())
            .then(
              (result) => {
                if ($("#rental_registration_number").length) {
                  $("#rental_registration_number").removeAttr("required");
                }
                for (var i in result) {
                  if (
                    $("#rental_registration_number").length &&
                    typeof result[i]["registration_requirement"] !==
                      "undefined" &&
                    result[i]["registration_requirement"]
                  ) {
                    $("#rental_registration_number").attr("required", true);
                  } else {
                    $("#rental_registration_number").removeAttr("required");
                  }
                  if ($(".edit-city-id").length) {
                    $(".edit-city-id").val(result[i]["id"]);
                    break;
                  }
                }
              },
              // Note: it's important to handle errors here
              // instead of a catch() block so that we don't swallow
              // exceptions from actual bugs in components.
              (error) => {
                console.log(JSON.stringify(error));
              }
            );
        }, 300);
      }
    }
  }

  setQuarter(quarterName) {
    clearTimeout(this.quarterSearchTimeout);
    this.quarterSearchTimeout = setTimeout(function () {
      if ($("#edit-quarter-id").length && $(".edit-quarter-id").val() !== "") {
        var quarterId = $(".edit-quarter-id").val();
        let jsonUrl = base_url + "/admin/autocomplete?q=" + quarterId + "&t=quarter";
          window
          .fetch(jsonUrl)
          .then((res) => res.json())
          .then(
            (result) => {
              $(".js-quarter").find(".name").text(result["name"]);
              $(".js-quarter")
              .find(".name")
              .append(
                '<svg class="icon close ms-1" width="10" height="10"><use href="#close"></use></svg>'
              );
              $(".js-quarter").removeClass('hide');
            },
            // Note: it's important to handle errors here
            // instead of a catch() block so that we don't swallow
            // exceptions from actual bugs in components.
            (error) => {
              console.log(JSON.stringify(error));
            }
          );
        }
        if(quarterName != undefined) {
          let jsonUrl =
          base_url +
          "/admin/autocomplete?q=" +
          quarterName +
          "&t=quarter&lat=" +
            $(".edit-latitude").val() +
            "&lng=" +
            $(".edit-longitude").val();
          window
          .fetch(jsonUrl)
          .then((res) => res.json())
            .then(
              (result) => {
                for (var i in result) {
                  if ($(".edit-quarter-id").length && result[i]["id"] != $(".edit-city-id").val() && result[i]["type"] == "quarter") {
                    $(".edit-quarter-id").val(result[i]["id"]);
                    $(".js-quarter").removeClass('hide');
                    break;
                  }
                }
              },
              // Note: it's important to handle errors here
              // instead of a catch() block so that we don't swallow
              // exceptions from actual bugs in components.
              (error) => {
                console.log(JSON.stringify(error));
              }
            );
          }
        }, 300);
      }
      
      componentDidMount() {
        this.keyupTimeout = null;
        this.setCityId();
        this.setQuarter();
        $wrapper.on("click", ".js-quarter .close", function () {
          $(".js-quarter").addClass('hide');
      $(".edit-quarter-id").val("");
    });
  }
  render() {
    return (
      //
      /*lat={this.state.lat} lng={this.state.lng}*/
      // Important! Always set the container height explicitly
      <div style={{ height: "250px", width: "100%" }}>
        <GoogleMapReact
          ref={this.mapRef} // Attach the ref to the GoogleMapReact component
          bootstrapURLKeys={{
            key: google_maps_key,
            language: lang,
            region: region.toLowerCase(),
          }}
          zoom={this.state.zoom}
          center={this.state.center}
          draggable={false}
          interactive={true}
          onChildMouseDown={this.onMarkerInteraction}
          onChildMouseUp={this.onMarkerRelease}
          onChildMouseMove={this.onMarkerInteraction}
          options={{
            gestureHandling: "cooperative",
            minZoom: min_zoom,
            maxZoom: max_zoom,
            streetViewControl: false,
            fullscreenControl: false,
            disableDefaultUI: false,
          }}
          onGoogleApiLoaded={({ map, maps }) => this.initMap(map, maps, 100)}
          yesIWantToUseGoogleMapApiInternals={true}
        >
          {this.state.markers ? (
            <SingleMarker
              lat={this.state.customLat || this.state.center.lat}
              lng={this.state.customLng || this.state.center.lng}
              index={this.state.packageValue || 3}
            />
          ) : (
            ""
          )}
        </GoogleMapReact>
      </div>
    );
  }
}
let lat = document.getElementsByClassName("edit-latitude")[0];
let lng = document.getElementsByClassName("edit-longitude")[0];
let packageName = document.getElementsByClassName("edit-package-name")[0];
let mapEdit = document.getElementById("editMap");

if (
  $("#address-edit").length &&
  typeof lat !== "undefined" &&
  typeof lng !== "undefined"
) {
  window.initEditMapDone = false;
  window.initEditMap = function () {
    if (!window.initEditMapDone) {
      const mapEditRoot = ReactDOM.createRoot(mapEdit);
      mapEditRoot.render(
        <MapEdit
          lat={lat.value || 0}
          lng={lng.value || 0}
          packageName={packageName.value}
        />
      );
      window.initEditMapDone = true;
    }
  };

  if (
    ($(".edit-latitude").val() != 0 && $(".edit-latitude").val() != 0) ||
    $(".geocoder[data-type=city]").val() != ""
  ) {
    window.initEditMap();
  } else {
    var startTimeout = null;
    $(".geocoder[data-type=city], #rental_formatted_location").one(
      "keyup input",
      function () {
        clearTimeout(startTimeout);
        startTimeout = setTimeout(function () {
          window.initEditMap();
        }, 100);
      }
    );
  }
}
